import { Link } from "react-router-dom";
import { useContent } from "@/context/ContentContext";
import RichText from "@/components/RichText";

export default function TermsOfUse() {
  const { t } = useContent();
  return (
    <div data-testid="terms-of-use-page">
      <section className="bg-ink-800 text-bone-50">
        <div className="section pt-24 pb-16 md:pt-32 md:pb-20">
          <div className="eyebrow !text-gold-400 mb-6">{t("terms.eyebrow", "Legal")}</div>
          <h1 className="font-serif font-light text-5xl sm:text-6xl lg:text-7xl leading-[1.05] tracking-tight">
            {t("terms.title", "Terms of Use")}
          </h1>
          <p className="mt-6 text-lg md:text-xl text-bone-100/80 leading-relaxed max-w-2xl font-light">
            {t("terms.subtitle")}
          </p>
          <div className="mt-8 text-xs uppercase tracking-[0.22em] text-gold-400">
            {t("terms.last_updated")}
          </div>
        </div>
      </section>

      <section className="section py-20 md:py-28 grid md:grid-cols-12 gap-12">
        <aside className="md:col-span-4">
          <div className="md:sticky md:top-32 border-t border-gold-500 pt-8">
            <div className="eyebrow mb-6">Related</div>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/privacy-policy" className="text-ink-800/80 hover:text-gold-600">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/cookie-policy" className="text-ink-800/80 hover:text-gold-600">Cookie Policy</Link>
              </li>
              <li>
                <Link to="/contact" className="text-ink-800/80 hover:text-gold-600">Contact us</Link>
              </li>
            </ul>
          </div>
        </aside>

        <article className="md:col-span-8 max-w-3xl">
          <RichText text={t("terms.body")} testId="terms-of-use-body" />
        </article>
      </section>
    </div>
  );
}
